import {gsap} from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import {breakpointUp, getScreenHeight} from '../utils/breakpoints';

gsap.registerPlugin(ScrollTrigger);

let headerImageTl;

window.headerImageContentInit = () => {
  const block = document.querySelector('.block-header-image-content');

  if (!block) return false;

  const clearHeaderImage = () => {
    if (headerImageTl) {
      ScrollTrigger.getById('headerImage').kill(true);
      gsap.set('.block-header-image-content .top-video-scroll-animation', {clearProps: true});
      gsap.set(['.top-video-scroll-animation .left-element', '.top-video-scroll-animation .right-element', '.top-video-scroll-animation .bottom-element', '.block-wrapper .about-us-header', '.scroll-content .inner-content', '.scroll-content-two .inner-content'], { clearProps: 'all' });
      headerImageTl.kill(true);
      headerImageTl = null;
    }
  }
  clearHeaderImage();

  if ($(window).width() > 991) {
    let scrollValue = '5rem';
    let startValue = 'top+=5% top+=5%';


    // ScrollTrigger small animation
    headerImageTl = gsap.timeline({
      scrollTrigger: {
        trigger: '.block-header-image-content',
        // markers: true,
        id: 'headerImage',
        scrub: true,
        start: startValue,
        end: 'bottom top',
        pin: true, // Pin the trigger element during the animation
        pinSpacing: true,
      },
    });


    headerImageTl.fromTo('.top-video-scroll-animation .left-element', {width: 0}, {width: scrollValue, duration: 1}, 0);
    headerImageTl.fromTo('.top-video-scroll-animation .right-element', {width: 0}, {
      width: scrollValue,
      duration: 1
    }, 0);
    headerImageTl.fromTo('.top-video-scroll-animation .bottom-element', {height: 0}, {
      height: scrollValue,
      duration: 1
    }, 0);

    headerImageTl.to('.block-wrapper .about-us-header', {y: '-100%', duration: 1, opacity: 0}, 0);
    headerImageTl.to('.scroll-content .inner-content', {y: '-100%', duration: 1, opacity: 0}, 0);
    headerImageTl.to('.scroll-content-two .inner-content', {y: '0', duration: 1, opacity: 1}, 0);
  }
}


headerImageContentInit();
